import React from "react";
import { Col, Form, Input, Modal, Row, Select, Radio, theme, Spin } from "antd";
import { PATCH, POST } from "../../frameworks/HttpClient";
import { URL_CHEMICAL, URL_SETTING } from "../../constants/urls";
import useDropdownItem from "../../common/useDropdownItem";
import ErrorMessages from "../../common/ErrorMessages";
import CustomDatePicker from "../../common/CustomDatePicker";
import _ from "lodash";
import dayjs from 'dayjs';

export default function AddStockChemicalModal(props) {

  const { open, onClose, target, onUpdate} = props;
  const [loading, setLoading] = React.useState(false);
  const [ errorMessages, setErrorMessages ] = React.useState(null);
  const [form] = Form.useForm();
  const isCreate = target === 'add'

  const [debouncedPureChemical, setDebouncedPureChemical] = React.useState('');
  const debouncePureChemical = React.useCallback(_.debounce((_searchVal) => { setDebouncedPureChemical(_searchVal) }, 800), []);
  const pureChemicalDropdown = useDropdownItem({manual: true, url: URL_CHEMICAL.PURE_CHEMICAL, label: 'name', value:'id', pagination: true, params: { page_size: 999, name: debouncedPureChemical } })


  const [debouncedSupplier, setDebouncedSupplier] = React.useState('');
  const debounceSupplier = React.useCallback(_.debounce((_searchVal) => { setDebouncedSupplier(_searchVal) }, 800), []);
  const supplierChemicalDropdown = useDropdownItem({manual: true, url: URL_SETTING.SELLER_CHEMICAL, label: 'name', value:'id', pagination: true, params: { page_size: 999, name :  debouncedSupplier}})
  


  const {
    token: { colorSuccess, colorWarning },
  } = theme.useToken();

  const handleOk = async() => {
    setLoading(true)
    setErrorMessages(null)
    try {
      const data = await form.validateFields()
      if(isCreate){
        await POST(URL_CHEMICAL.PURE_CHEMICAL_TRANSACTION, data)
      } else {
        await PATCH(`${URL_CHEMICAL.PURE_CHEMICAL_TRANSACTION}${target.id}/`, data)
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    if(open){
      setErrorMessages(null)
      supplierChemicalDropdown.fetchOptions();
      pureChemicalDropdown.fetchOptions();
      if(isCreate){
        form.resetFields();
        form.setFieldValue('input_date', dayjs().format('YYYY-MM-DD'))
      } else {
        form.setFieldsValue(target)
        console.log(!dayjs().isSame(dayjs(_.get(target, 'input_date', '')), 'day'))
        // supplierChemicalDropdown.addOption({name : target.supplier_name, id: target.supplier, value : target.supplier});
        // pureChemicalDropdown.addOption({name : target.chemical_name, id: target.chemical, value : target.chemical});
      }
    }
  },[open])


  React.useEffect(() => {
    if(open)
      pureChemicalDropdown.fetchOptions();
  },[debouncedPureChemical])

  React.useEffect(() => {
    if(open)
      supplierChemicalDropdown.fetchOptions();
  },[debouncedSupplier])


	return(
    <Modal
      open={open}
      onCancel={onClose}
      okText={isCreate ? "ตกลง" : "แก้ไข"}
      okButtonProps={{ style: { backgroundColor : isCreate ? colorSuccess : colorWarning}, loading: loading }}
      cancelText={"ไม่"}
      cancelButtonProps={{ loading: loading }}
      title={isCreate ? "เพิ่มสต๊อกเคมีภัณฑ์" : "แก้ไขข้อมูลเคมีภัณฑ์"}
      width={600}
      onOk={handleOk}
    >
      <ErrorMessages message={errorMessages}/>
      <Form
        form={form}
        layout={'vertical'}
      >
        <Row>
          <Col span={12}>
            <CustomDatePicker
              label={'วันที่นำเข้า'} 
              name={"input_date"}
              rules={[{ required : true, message: "กรุณาเลือกวันที่นำเข้า!"  }]}
              disabled={true}
            />
          </Col>
          <Col span={12}>
            <Form.Item 
              label={'Lot No.'} 
              style={{ marginRight : 10}}
              name={"lot_no"}
              rules={[{ required : true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Input style={{ width : '100%' }} placeholder={'Lot No.'} autoComplete="off"/>
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item 
              label={'ชื่อสารเคมี'} 
              style={{marginRight : 10}}
              name={"chemical"}
              rules={[{ required : true, message: "กรุณาเลือกชื่อสารเคมี!"  }]}
            >
              <Select 
                showSearch
                style={{ width : '100%' }} 
                placeholder={'ชื่อสารเคมี'} 
                options={pureChemicalDropdown.options}
                filterOption={false}
                notFoundContent={pureChemicalDropdown.loading ? <Spin size="small" /> : "-"}
                onSearch={debouncePureChemical}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item 
              label={'ปริมาณที่รับเข้า'} 
              style={{marginRight : 10}}
              name={'amount'}
              rules={[{ required : true, message: "กรุณาใส่ปริมาณ!"  }]}
            >
              <Input 
                style={{ width : '100%' }} 
                placeholder={'ปริมาณที่รับเข้า'} 
                autoComplete="off" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <CustomDatePicker 
              label={'วันที่ผลิต'} 
              name={'produce_date'}
              style={{ marginRight : 10}}
            />
          </Col>
          <Col span={12}>
            <CustomDatePicker
              label={'วันที่หมดอายุ'} 
              name={'expire_date'}
              style={{ marginRight : 10}}
            />
          </Col>
          <Col span={24}>
            <Form.Item 
              label={'บริษัทผู้จำหน่าย'} 
              name={"supplier"}
              style={{ marginRight : 10}}
              rules={[{ required : true, message: "กรุณาใส่บริษัทผู้จำหน่าย!"  }]}
            >
              <Select 
                showSearch
                style={{ width : '100%' }} 
                placeholder={'บริษัทผู้จำหน่าย'}
                options={supplierChemicalDropdown.options}
                onSearch={debounceSupplier}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item 
              label={'คุณภาพ'} 
              name={'is_qc_passed'}
              style={{ marginRight : 10}}
              layout='horizontal'
              rules={[{ required : true, message: "กรุณาใส่คุณภาพ!"  }]}
            >
              <Radio.Group 
                style={{ marginLeft : 10}}
              >
                <Radio value={true}>ผ่าน</Radio>
                <Radio value={false}>ไม่ผ่าน</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item 
              label={'หมายเหตุ'} 
              name={'note'}
              style={{ marginRight : 10}}
            >
              <Input.TextArea style={{ width : '100%' }} placeholder={'รายละเอียด'} autoComplete="off"/>
            </Form.Item>
          </Col>

        </Row>
      </Form>
    </Modal>
)
}